import { render, staticRenderFns } from "./punch_item.vue?vue&type=template&id=2f761c13&scoped=true"
import script from "./punch_item.vue?vue&type=script&lang=js"
export * from "./punch_item.vue?vue&type=script&lang=js"
import style0 from "./punch_item.vue?vue&type=style&index=0&id=2f761c13&prod&lang=css"
import style1 from "./punch_item.vue?vue&type=style&index=1&id=2f761c13&prod&scoped=true&lang=css"
import style2 from "./punch_item.vue?vue&type=style&index=2&id=2f761c13&prod&scoped=true&lang=css"
import style3 from "./punch_item.vue?vue&type=style&index=3&id=2f761c13&prod&scoped=true&lang=css"
import style4 from "./punch_item.vue?vue&type=style&index=4&id=2f761c13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f761c13",
  null
  
)

export default component.exports